var src = process.env.src;
if (!src) {
    console.log("source config is missing!");
    throw "source config is missing!";
}
var tries = 0;
function loadWidget(placeholders) {
    placeholders.forEach(function (placeholder) {
        var _a, _b;
        if (((_a = placeholder === null || placeholder === void 0 ? void 0 : placeholder.dataset) === null || _a === void 0 ? void 0 : _a.vendor) && ((_b = placeholder === null || placeholder === void 0 ? void 0 : placeholder.dataset) === null || _b === void 0 ? void 0 : _b.category)) {
            loadWidgetFromIdAndDataAttributes(placeholder); // remove as soon as sheego changed integration
        }
        else {
            loadWidgetFromId(placeholder);
        }
    });
}
function loadWidgetFromId(placeholder) {
    var _a, _b;
    var _c, _d, _e, _f;
    if (!placeholder.id) {
        console.error("innofind placeholder has no id");
        return;
    }
    var elementId = placeholder.id;
    var vendor, type, category, mode, listurl, position, entrypage, producttileIndex;
    var fourthElement = elementId.split("::")[4];
    var modeIsFourthElement = ["teaser", "list", "link"].some(function (mode) { return fourthElement === mode; });
    if (modeIsFourthElement) {
        // TODO remove as soon as ochsner shoes changed integration on stilfinder page
        _a = elementId.split("::"), vendor = _a[1], type = _a[2], category = _a[3], mode = _a[4], listurl = _a[5];
    }
    else {
        _b = elementId.split("::"), vendor = _b[1], category = _b[2], mode = _b[3], entrypage = _b[4], position = _b[5], producttileIndex = _b[6];
        // This should be default as soon as ochsnerl changed
        entrypage = entrypage || ((_c = placeholder === null || placeholder === void 0 ? void 0 : placeholder.dataset) === null || _c === void 0 ? void 0 : _c.page);
        position = position || ((_d = placeholder === null || placeholder === void 0 ? void 0 : placeholder.dataset) === null || _d === void 0 ? void 0 : _d.position);
        producttileIndex =
            producttileIndex || ((_e = placeholder === null || placeholder === void 0 ? void 0 : placeholder.dataset) === null || _e === void 0 ? void 0 : _e.producttileIndex);
        listurl = (_f = placeholder === null || placeholder === void 0 ? void 0 : placeholder.dataset) === null || _f === void 0 ? void 0 : _f.listurl;
    }
    if (mode === "teaser" || mode === "list") {
        var script = document.createElement("script");
        script.onload = function () {
            //add widget to placeholder
            var widget = document.createElement("innofind-widget");
            widget.setAttribute("vendor", vendor);
            widget.setAttribute("category", category);
            widget.setAttribute("entrypage", entrypage || type); // TODO remove type as soon as old integration from sheego and ochsner are removed
            widget.setAttribute("entrypoint", entrypage || type); // TODO change
            widget.setAttribute("position", position);
            widget.setAttribute("listurl", listurl);
            if (placeholder.id.indexOf("list") > -1) {
                widget.setAttribute("forceplp", "true");
            }
            placeholder.innerHTML = ""; // importent to remove all previous widgets in this placeholder to avoid multiple widgets if the js is loaded more than once
            placeholder.appendChild(widget);
        };
        script.src = src;
        document.head.appendChild(script);
    }
    else if (mode === "link") {
        var link = document.createElement("a");
        link.innerHTML = placeholder.outerHTML;
        link.setAttribute("href", listurl + "?inno-forceplp=true&inno-category=" + category);
        placeholder.parentNode.insertBefore(link, placeholder);
        placeholder.remove();
    }
}
// @deprecated old version (only used by sheego)
function loadWidgetFromIdAndDataAttributes(placeholder) {
    var requiredAttribues = ["vendor", "category", "id", "listurl"];
    requiredAttribues.forEach(function (e) {
        if (!(e in placeholder.dataset)) {
            console.warn("missing required attribute: ", e);
        }
    });
    if (placeholder.id.indexOf("teaser") > -1 ||
        placeholder.id.indexOf("list") > -1) {
        var script = document.createElement("script");
        script.onload = function () {
            //add widget to placeholder
            var widget = document.createElement("innofind-widget");
            widget.setAttribute("vendor", placeholder.dataset.vendor);
            widget.setAttribute("category", placeholder.dataset.category);
            widget.setAttribute("entrypoint", placeholder.dataset.type);
            widget.setAttribute("position", placeholder.dataset.position);
            widget.setAttribute("listurl", placeholder.dataset.listurl);
            if (placeholder.id.indexOf("list") > -1) {
                widget.setAttribute("forceplp", "true");
            }
            placeholder.appendChild(widget);
        };
        script.src = src;
        document.head.appendChild(script);
    }
    else if (placeholder.id.indexOf("link") > -1) {
        var link = document.createElement("a");
        link.innerHTML = placeholder.outerHTML;
        link.setAttribute("href", placeholder.dataset.listurl +
            "?inno-forceplp=true&inno-category=" +
            placeholder.dataset.category);
        placeholder.parentNode.insertBefore(link, placeholder);
        placeholder.remove();
    }
}
function init() {
    var placeholders = document.querySelectorAll("[id^=innofind]");
    if ((!placeholders || placeholders.length == 0) && tries < 20) {
        setTimeout(init, 100);
        tries++;
    }
    else {
        loadWidget(placeholders);
    }
}
init();
